import React from 'react';
import Cookies from "universal-cookie";
import host from '../../assets/js/Host';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import * as moment from "moment-timezone";

const cookies = new Cookies();

// نفس معجم أنماط StockTransfer — الصفحتان تُقرآن معاً فاختلاف
// الشكل بينهما يوهم أنهما نظامان مختلفان.
const S = {
  page: { padding: 24, direction: "rtl", background: "#f8fafc", minHeight: "100vh", fontFamily: "'Segoe UI', Tahoma, sans-serif" },
  pageInner: { paddingInline: "max(24px, calc((100% - 1180px) / 2))", boxSizing: "border-box" },
  h1: { fontSize: 24, fontWeight: 800, color: "#0f172a", margin: "0 0 6px" },
  sub: { fontSize: 13, color: "#64748b", margin: "0 0 20px" },
  card: { background: "#fff", borderRadius: 16, boxShadow: "0 1px 3px rgba(0,0,0,.08)", border: "1px solid #eef2f7", marginBottom: 16 },
  pad: { padding: 20 },
  input: { padding: "12px 14px", borderRadius: 10, border: "1px solid #e2e8f0", fontSize: 15, outline: "none", fontFamily: "inherit" },
  btnPrimary: { padding: "12px 22px", borderRadius: 10, border: "none", background: "#2563eb", color: "#fff", fontWeight: 700, cursor: "pointer", fontSize: 15 },
  btnGhost: { padding: "9px 16px", borderRadius: 9, border: "1px solid #e2e8f0", background: "#fff", color: "#334155", fontWeight: 600, cursor: "pointer", fontSize: 13 },
  th: { textAlign: "right", padding: "11px 12px", fontSize: 12, color: "#64748b", fontWeight: 700, borderBottom: "2px solid #f1f5f9" },
  td: { textAlign: "right", padding: "12px", fontSize: 13.5, color: "#0f172a", borderBottom: "1px solid #f8fafc", verticalAlign: "top" },
  stat: { flex: 1, minWidth: 150, padding: "16px 18px", background: "#fff", borderRadius: 14, border: "1px solid #eef2f7" },
  statLabel: { fontSize: 12, color: "#64748b", fontWeight: 600, marginBottom: 5 },
  statValue: { fontSize: 24, fontWeight: 800, color: "#0f172a" },
  chip: { display: "inline-block", padding: "2px 8px", borderRadius: 12, fontSize: 11, fontWeight: 600, background: "#eff6ff", color: "#2563eb", border: "1px solid #dbeafe", marginInlineEnd: 4, marginBottom: 3 },
  empty: { padding: 50, textAlign: "center", color: "#94a3b8", fontSize: 15 },
  badge: (bg, color) => ({ display: "inline-block", padding: "3px 11px", borderRadius: 20, fontSize: 12, fontWeight: 700, background: bg, color }),
  tabs: { display: "flex", gap: 8, marginBottom: 16, flexWrap: "wrap" },
  tab: (on) => ({
    padding: "11px 20px", borderRadius: 11, cursor: "pointer", fontSize: 14, fontWeight: 700,
    border: on ? "1px solid #2563eb" : "1px solid #e2e8f0",
    background: on ? "#2563eb" : "#fff", color: on ? "#fff" : "#334155",
  }),
  warnBox: { padding: "13px 16px", borderRadius: 11, background: "#fffbeb", border: "1px solid #fde68a", color: "#92400e", fontSize: 13.5, marginBottom: 14, fontWeight: 600 },

  // ===== الخط الزمني =====
  // العمود على اليمين لأن الصفحة rtl — الخط يجب أن يبدأ من حيث
  // تبدأ القراءة، وإلا قرأ الفني الأحداث معكوسة.
  tlWrap: { position: "relative", paddingInlineStart: 4, paddingInlineEnd: 26 },
  tlLine: { position: "absolute", top: 8, bottom: 8, insetInlineEnd: 9, width: 2, background: "#e2e8f0" },
  tlRow: { position: "relative", display: "flex", gap: 14, paddingBottom: 18 },
  tlDot: (custody) => ({
    position: "absolute", insetInlineEnd: -22, top: 4,
    width: 14, height: 14, borderRadius: "50%",
    background: custody ? "#2563eb" : "#fff",
    border: custody ? "3px solid #bfdbfe" : "3px solid #e2e8f0",
    boxSizing: "border-box",
  }),
  tlBody: { flex: 1, background: "#f8fafc", border: "1px solid #eef2f7", borderRadius: 12, padding: "11px 14px" },
  tlHead: { display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap", marginBottom: 4 },
  tlAction: { fontSize: 14.5, fontWeight: 800, color: "#0f172a" },
  tlActor: { fontSize: 12.5, fontWeight: 700, color: "#2563eb" },
  tlDate: { fontSize: 11.5, color: "#94a3b8", marginInlineStart: "auto" },
  tlNote: { fontSize: 12.5, color: "#475569", lineHeight: 1.7 },
  tlFlow: { fontSize: 11.5, color: "#64748b", fontFamily: "monospace", marginTop: 3 },
};

const fmt = (n) => {
  const v = Number(n) || 0;
  return v % 1 === 0 ? v.toLocaleString("en-US")
    : v.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

const STATUS_AR = {
  ready: "جاهز", sana: "صيانة", soft: "سوفت",
  stocked: "في المخزن", sold: "مباع", needs_fix: "للتصحيح",
};
const statusAr = (s) => STATUS_AR[s] || s || "—";

export default class DeviceLogs extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tab: "device",     // device | responsible
      query: "",
      device: null,      // رد /purchase/device/logs
      loadingDevice: false,

      report: null,      // رد /purchase/responsible (التوزيع)
      loadingReport: false,
      openAdmin: null,   // { admin_id, ... } أجهزة موظف بعينه
      loadingAdmin: false,
    };
  }

  componentDidMount() {
    this.loadReport();
  }

  header() { return { "Content-Type": "application/json", token: cookies.get("token") }; }

  // ===== سلسلة جهاز =====
  //
  // الاستعلام يقبل الثلاثة (رقم · سيريال · ماك) والخادم يقرّر:
  // الفني يقرأ ما هو أمامه — الملصق أو الشاشة أو الكيبل.
  loadDevice = () => {
    const q = String(this.state.query || "").trim();
    if (!q) return;

    // ماك؟ فيه نقطتان أو شرطات بنمط الماك
    const isMac = /^([0-9a-f]{2}[:-]){5}[0-9a-f]{2}$/i.test(q);
    const isNum = /^\d+$/.test(q);
    const param = isMac ? `mac=${encodeURIComponent(q)}`
      : isNum ? `id=${encodeURIComponent(q)}`
        : `sn=${encodeURIComponent(q)}`;

    this.setState({ loadingDevice: true });
    axios.get(host + `purchase/device/logs?${param}`, { headers: this.header() })
      .then(res => {
        this.setState({ device: (res.data && res.data.data) || res.data, loadingDevice: false });
      })
      .catch(err => {
        const m = err.response?.data?.message || "تعذّر جلب سلسلة الجهاز";
        toast.error(typeof m === "string" ? m : "تعذّر جلب سلسلة الجهاز");
        this.setState({ loadingDevice: false, device: null });
      });
  };

  onKey = (e) => { if (e.key === "Enter") this.loadDevice(); };

  // ===== التوزيع على الموظفين =====
  loadReport = () => {
    this.setState({ loadingReport: true });
    axios.get(host + `purchase/responsible`, { headers: this.header() })
      .then(res => {
        this.setState({ report: (res.data && res.data.data) || res.data, loadingReport: false });
      })
      .catch(() => {
        toast.error("تعذّر جلب تقرير المسؤولية");
        this.setState({ loadingReport: false });
      });
  };

  loadAdmin = (adminId) => {
    this.setState({ loadingAdmin: true, openAdmin: null });
    axios.get(host + `purchase/responsible?admin_id=${adminId}`, { headers: this.header() })
      .then(res => {
        this.setState({ openAdmin: (res.data && res.data.data) || res.data, loadingAdmin: false });
      })
      .catch(() => {
        toast.error("تعذّر جلب أجهزة الموظف");
        this.setState({ loadingAdmin: false });
      });
  };

  renderTimeline(d) {
    const tl = Array.isArray(d.timeline) ? d.timeline : [];
    if (!tl.length) {
      return (
        <div style={S.empty}>
          ما في أحداث مسجّلة لهذا الجهاز.
          <div style={{ fontSize: 13, marginTop: 8 }}>
            الأجهزة المُدخلة قبل تشغيل السجل تحمل أسطر البداية المزروعة فقط.
          </div>
        </div>
      );
    }

    return (
      <div style={S.tlWrap}>
        <div style={S.tlLine} />
        {tl.map(ev => (
          <div key={ev.id} style={S.tlRow}>
            <div style={S.tlDot(ev.is_custody)} />
            <div style={S.tlBody}>
              <div style={S.tlHead}>
                <span style={S.tlAction}>{ev.action_label}</span>
                {/* النقطة الممتلئة = انتقلت المسؤولية. الفرق بصري لأن
                    الفني يحتاج يعرف بلمحة وين تسلّم الجهاز يداً بيد. */}
                {ev.is_custody ? (
                  <span style={S.badge("#eff6ff", "#2563eb")}>تسليم</span>
                ) : null}
                <span style={S.tlActor}>
                  {ev.actor_name ? ev.actor_name : "— غير معروف"}
                </span>
                <span style={S.tlDate}>
                  {ev.createdAt ? moment(ev.createdAt).format("YYYY-MM-DD HH:mm:ss") : ""}
                </span>
              </div>

              {(ev.from_status || ev.to_status) ? (
                <div style={S.tlFlow}>
                  {statusAr(ev.from_status)} ← {statusAr(ev.to_status)}
                  {ev.ref_type ? `  ·  ${ev.ref_type} #${ev.ref_id ?? "—"}` : ""}
                </div>
              ) : null}

              {ev.note ? <div style={S.tlNote}>{ev.note}</div> : null}

              {/* السيريال يُعرض فقط إذا اختلف عن الحالي: تغيّره يعني
                  تبديل بورد أو فتحاً، وهو أهم ما في السلسلة. */}
              {ev.sn && d.sn && ev.sn !== d.sn ? (
                <div style={S.tlNote}>
                  <span style={S.chip}>السيريال وقتها: {ev.sn}</span>
                </div>
              ) : null}
            </div>
          </div>
        ))}
      </div>
    );
  }

  renderDeviceTab() {
    const { device, loadingDevice } = this.state;

    return (
      <>
        <div style={S.card}>
          <div style={{ ...S.pad, display: "flex", gap: 10, flexWrap: "wrap", alignItems: "center" }}>
            <input
              style={{ ...S.input, flex: 1, minWidth: 240 }}
              placeholder="رقم الجهاز أو السيريال أو الماك…"
              value={this.state.query}
              onChange={e => this.setState({ query: e.target.value })}
              onKeyPress={this.onKey}
              autoFocus
            />
            <button style={S.btnPrimary} onClick={this.loadDevice} disabled={loadingDevice}>
              {loadingDevice ? "…" : "اعرض السلسلة"}
            </button>
          </div>
        </div>

        {!device ? (
          <div style={{ ...S.card, ...S.empty }}>
            امسح باركود الجهاز أو أدخل رقمه لعرض سلسلته من الإدخال حتى آخر حدث.
          </div>
        ) : (
          <>
            <div style={{ display: "flex", gap: 12, flexWrap: "wrap", marginBottom: 16 }}>
              <div style={S.stat}>
                <div style={S.statLabel}>الجهاز</div>
                <div style={S.statValue}>#{device.device_id}</div>
                <div style={{ fontSize: 12.5, color: "#475569", marginTop: 4 }}>
                  {device.composite_name}
                </div>
              </div>
              <div style={S.stat}>
                <div style={S.statLabel}>المسؤول الحالي</div>
                <div style={{ ...S.statValue, fontSize: 19 }}>
                  {device.responsible?.name || "— بلا مسؤول"}
                </div>
                {device.responsible?.since ? (
                  <div style={{ fontSize: 12, color: "#94a3b8", marginTop: 4 }}>
                    منذ {moment(device.responsible.since).format("YYYY-MM-DD HH:mm")}
                  </div>
                ) : null}
              </div>
              <div style={S.stat}>
                <div style={S.statLabel}>الحالة</div>
                <div style={{ ...S.statValue, fontSize: 19 }}>{statusAr(device.status)}</div>
              </div>
              <div style={S.stat}>
                <div style={S.statLabel}>عدد الأحداث</div>
                <div style={S.statValue}>{device.count}</div>
              </div>
            </div>

            {device.previous_sn ? (
              <div style={S.warnBox}>
                هذا الجهاز تغيّر سيرياله: الحالي <b>{device.sn}</b> والسابق <b>{device.previous_sn}</b>.
                السلسلة كاملة لأنها مربوطة برقم الجهاز لا بالسيريال.
              </div>
            ) : null}

            <div style={S.card}>
              <div style={S.pad}>{this.renderTimeline(device)}</div>
            </div>
          </>
        )}
      </>
    );
  }

  renderResponsibleTab() {
    const { report, loadingReport, openAdmin, loadingAdmin } = this.state;

    if (loadingReport) return <div style={{ ...S.card, ...S.empty }}>…</div>;
    if (!report) return <div style={{ ...S.card, ...S.empty }}>ما في بيانات.</div>;

    const rows = Array.isArray(report.by_admin) ? report.by_admin : [];

    return (
      <>
        {report.unassigned ? (
          <div style={S.warnBox}>
            {report.unassigned} جهاز بلا مسؤول — إمّا دخل قبل تشغيل السجل،
            أو مرّ بنقطة لم تُرسل توكن الموظف.
          </div>
        ) : null}

        <div style={S.card}>
          <div style={S.pad}>
            <div style={{ ...S.h1, fontSize: 18 }}>من يحمل ماذا الآن</div>
            <div style={S.sub}>
              المسؤول = آخر من استلم الجهاز يداً بيد. المباع مستبعد — خرج للزبون.
            </div>

            {!rows.length ? (
              <div style={S.empty}>ما في أجهزة تحت مسؤولية أحد.</div>
            ) : (
              <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <thead>
                  <tr>
                    <th style={S.th}>الموظف</th>
                    <th style={S.th}>الكل</th>
                    <th style={S.th}>صيانة</th>
                    <th style={S.th}>سوفت</th>
                    <th style={S.th}>جاهز</th>
                    <th style={S.th}>في المخزن</th>
                    <th style={S.th}>في قائمة تحويل</th>
                    <th style={S.th}>التكلفة</th>
                    <th style={S.th}></th>
                  </tr>
                </thead>
                <tbody>
                  {rows.map((r, i) => (
                    <tr key={r.admin_id || `x${i}`}>
                      <td style={{ ...S.td, fontWeight: 700 }}>{r.admin_name}</td>
                      <td style={S.td}>
                        <span style={S.badge("#eff6ff", "#2563eb")}>{r.total}</span>
                      </td>
                      <td style={S.td}>{r.sana || "—"}</td>
                      <td style={S.td}>{r.soft || "—"}</td>
                      <td style={S.td}>{r.ready || "—"}</td>
                      <td style={S.td}>{r.stocked || "—"}</td>
                      <td style={S.td}>{r.in_transfer_list || "—"}</td>
                      <td style={S.td}>{fmt(r.total_cost)}</td>
                      <td style={S.td}>
                        {r.admin_id ? (
                          <button style={S.btnGhost} onClick={() => this.loadAdmin(r.admin_id)}>
                            الأجهزة
                          </button>
                        ) : null}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </div>

        {loadingAdmin ? <div style={{ ...S.card, ...S.empty }}>…</div> : null}

        {openAdmin ? (
          <div style={S.card}>
            <div style={S.pad}>
              <div style={{ display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap", marginBottom: 12 }}>
                <div style={{ ...S.h1, fontSize: 18, margin: 0 }}>
                  أجهزة {openAdmin.admin_name}
                </div>
                <span style={S.badge("#eff6ff", "#2563eb")}>{openAdmin.count} جهاز</span>
                <span style={S.badge("#f8fafc", "#475569")}>تكلفة {fmt(openAdmin.total_cost)}</span>
                <button
                  style={{ ...S.btnGhost, marginInlineStart: "auto" }}
                  onClick={() => this.setState({ openAdmin: null })}
                >
                  إغلاق
                </button>
              </div>

              {!openAdmin.devices?.length ? (
                <div style={S.empty}>ما في أجهزة.</div>
              ) : (
                <table style={{ width: "100%", borderCollapse: "collapse" }}>
                  <thead>
                    <tr>
                      <th style={S.th}>الرقم</th>
                      <th style={S.th}>الاسم المركّب</th>
                      <th style={S.th}>السيريال</th>
                      <th style={S.th}>الحالة</th>
                      <th style={S.th}>مسؤول منذ</th>
                      <th style={S.th}>التكلفة</th>
                      <th style={S.th}></th>
                    </tr>
                  </thead>
                  <tbody>
                    {openAdmin.devices.map(d => (
                      <tr key={d.id}>
                        <td style={{ ...S.td, fontWeight: 700 }}>#{d.id}</td>
                        <td style={S.td}>
                          {d.composite_name}
                          {d.was_returned ? (
                            <span style={{ ...S.chip, background: "#fffbeb", color: "#92400e", border: "1px solid #fde68a" }}>
                              رجع {d.return_count} مرة
                            </span>
                          ) : null}
                        </td>
                        <td style={{ ...S.td, fontFamily: "monospace", fontSize: 12.5 }}>{d.sn}</td>
                        <td style={S.td}>{statusAr(d.status)}</td>
                        <td style={{ ...S.td, fontSize: 12.5, color: "#64748b" }}>
                          {d.responsible_since ? moment(d.responsible_since).format("MM-DD HH:mm") : "—"}
                        </td>
                        <td style={S.td}>{fmt(d.total_cost)}</td>
                        <td style={S.td}>
                          <button
                            style={S.btnGhost}
                            onClick={() => this.setState(
                              { tab: "device", query: String(d.id) },
                              this.loadDevice,
                            )}
                          >
                            السلسلة
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
          </div>
        ) : null}
      </>
    );
  }

  render() {
    if (!cookies.get("token")) return <div style={S.page}>يجب تسجيل الدخول</div>;
    const { tab } = this.state;

    return (
      <div style={S.page}>
        <div style={S.pageInner}>
          <h1 style={S.h1}>سجل الأجهزة والمسؤولية</h1>
          <p style={S.sub}>
            كل مرحلة يمرّ بها الجهاز — من الإدخال حتى التحويل للمخزن — بمن نفّذها.
          </p>

          <div style={S.tabs}>
            <div style={S.tab(tab === "device")} onClick={() => this.setState({ tab: "device" })}>
              سلسلة جهاز
            </div>
            <div
              style={S.tab(tab === "responsible")}
              onClick={() => this.setState({ tab: "responsible" }, this.loadReport)}
            >
              أجهزة الموظفين
            </div>
          </div>

          {tab === "device" ? this.renderDeviceTab() : this.renderResponsibleTab()}
        </div>

        <ToastContainer position="top-center" autoClose={3000} rtl theme="colored" />
      </div>
    );
  }
}
